export const ADD_FORM = 'ADD_FORM';
export const ADD_FORM_RESPONSE = 'ADD_FORM_RESPONSE';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_ROLES_LIST = 'SET_ROLES_LIST';
export const GET_WORKTYPES = 'GET_WORKTYPES';
export const GET_ALL_FORMS = 'GET_ALL_FORMS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_FORM_LIST_LOADING = 'SET_FORM_LIST_LOADING';
